// General
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// Redux
import { connect } from 'react-redux';

// Asset
import defaultPic from './user-solid.svg';
import { buildAvatarPath } from './../../helpers/photoutils';
import cx from 'classnames';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Avatar.css';

// Component
import Link from '../Link';
import styled from 'styled-components';
import { colors } from './../../tailwind';

class Avatar extends React.Component {
  static propTypes = {
    source: PropTypes.string,
    title: PropTypes.string,
    height: PropTypes.number,
    width: PropTypes.number,
    className: PropTypes.string,
    withLink: PropTypes.bool,
    profileId: PropTypes.number,
    linkClassName: PropTypes.string,
    profilePictureData: PropTypes.shape({
      loading: PropTypes.bool,
      account: PropTypes.shape({
        picture: PropTypes.string,
      }),
    }),
    isUser: PropTypes.bool,
    type: PropTypes.string,
    staticImage: PropTypes.bool,
  };

  static defaultProps = {
    source: null,
    height: 100,
    width: 100,
    profileId: null,
    withLink: false,
    profilePictureData: {
      loading: true,
      userAccount: {
        picture: null,
      },
    },
    isUser: false,
    type: 'medium',
    staticImage: false,
  };

  render() {
    const {
      source,
      title,
      height,
      width,
      className,
      withLink,
      linkClassName,
      profileId,
      profilePictureData: { loading, userAccount },
      isUser,
      type,
      staticImage,
    } = this.props;
    let imgSource = defaultPic;

    if (loading) {
      return null;
    }

    if (isUser) {
      if (staticImage) {
        imgSource = source !== null ? source : defaultPic;
      } else if (!loading && userAccount != null) {
        imgSource =
          userAccount.picture !== null
            ? buildAvatarPath(userAccount.picture, type)
            : defaultPic;
      }
    } else if (staticImage) {
      imgSource = source !== null ? source : defaultPic;
    } else {
      imgSource = source !== null ? buildAvatarPath(source, type) : defaultPic;
    }

    if (withLink) {
      return (
        <Link to={`/users/show/${profileId}`} className={linkClassName}>
          <img
            src={imgSource}
            className={cx(s.imgBackground, className)}
            alt={title}
            height={height}
            width={width}
            style={{ borderRadius: '50%', minHeight: height, minWidth: width }}
          />
        </Link>
      );
    }
    return (
      <ImgContainer
        style={{
          height,
          width,
        }}
      >
        <Img src={imgSource} alt={title} style={{ borderRadius: '50%' }} />
      </ImgContainer>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(
    gql`
      query {
        userAccount {
          picture
        }
      }
    `,
    {
      name: 'profilePictureData',
      options: props => ({
        skip: !props.isUser,
        ssr: false,
      }),
    },
  ),
)(Avatar);

const ImgContainer = styled.div`
  position: relative;

  width: 37%; /* The size you want */
  &:after {
    content: '';
    display: block;
    padding-bottom: 100%; /* The padding depends on the width, not on the height, so with a padding-bottom of 100% you will get a square */
  }
`;

const Img = styled.img`
  position: absolute; /* Take your picture out of the flow */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0; /* Make the picture taking the size of it's parent */
  width: 100%; /* This if for the object-fit */
  height: 100%; /* This if for the object-fit */
  object-fit: contain; /* Equivalent of the background-size: cover; of a background-image */
  object-position: center;
  background-color: ${colors.coolGrayLighter};
`;



// WEBPACK FOOTER //
// ./src/components/Avatar/Avatar.js